import { useParams } from "react-router-dom";
import $ from 'jquery';
import abgrcs_config from './abgrcs_config.js';

function Single() {
  const params = useParams();

  var single_id = params.id;
  
  var abgrcs_nav_header2 = new Array();

  for (let index2 = 0; index2 < Object.keys(abgrcs_config.service_array[single_id].single_img_more).length; index2++) {
    abgrcs_nav_header2.push(
      <>
        <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3 item" data-aos="fade" data-src={abgrcs_config.service_array[single_id].single_img_more[index2].image_url} data-sub-html={"<h4>" + abgrcs_config.service_array[single_id].single_img_more[index2].image_description + "</p>"}>
          <a href="#"><img src={abgrcs_config.service_array[single_id].single_img_more[index2].image_url} alt="IMage" class="img-fluid" /></a>
        </div>
      </>
    );
  }
  
  var abgrcs_nav_header2 = (
    abgrcs_nav_header2
  );

  return [
    <div class="row justify-content-center">
      <div class="col-md-7">
        <div class="row mb-5">
          <div class="col-12 ">
            <h2 class="site-section-heading text-center">Portrait Gallery</h2>
          </div>
        </div>
      </div>
    </div>,
    <div class="row" id="lightgallery">
      {abgrcs_nav_header2}
    </div>
  ];
}

export default Single;

/*
function paragraph_add_show(paragraph_id)
{
	$("#paragraph_title").val("");
  
  $("#model_paragraph_bar_title").html("Add Paragraph");
  $("#model_paragraph_bnt_add_edit").html("Add");
  $("#model_paragraph_bnt_add_edit").attr("onclick", "paragraphs_add();");
  
  window.$('#model_paragraphs_add').modal('show');
}
*/